import { render, staticRenderFns } from "./WeekSlider.vue?vue&type=template&id=72698bae&scoped=true&"
import script from "./WeekSlider.vue?vue&type=script&lang=js&"
export * from "./WeekSlider.vue?vue&type=script&lang=js&"
import style0 from "./WeekSlider.vue?vue&type=style&index=0&id=72698bae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72698bae",
  null
  
)

export default component.exports